module.exports = __webpack_public_path__ + "media/images/porque/art-ted-6abbe76972eed4ca107d9893749fa0b3.svg";